import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledProjectDetailsAccessAbsenceContainer = styled(Flexbox)(
    ({theme}) => css`
        display: grid;
        width: 100%;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        grid-template-rows: auto minmax(0, 1fr);
        gap: ${theme.spacing * 4}px;
    `
)
